import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  computed,
  effect,
  Inject,
  inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  signal,
  ViewChild,
  viewChild,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterModule,
} from '@angular/router';
import { SpinnerComponent, SpinnerService } from '@sml/spinner';
import { FormSpinnerComponent } from '@sml/form-spinner';

import { ToastrComponent, ToastrService } from '@sml/toastr';
import {
  CommunitySignalService,
  CustomizePlaquesService,
  IFileModel,
  IStoryModel,
  ITEM_STATUS_TYPE,
  ItemModel,
  ItemService,
  PlatformService,
  ICampaignItem,
  ItemDetails,
  LocationDetails,
  PriceModel,
  Donation,
  ItemDates,
  POST_ITEM_TYPE,
  StoryDialogConfig,
  StoryPlaquesService,
  TitleService,
  ViewStoryService,
  StorytellerSignalSignalService,
  ViewParticipateService,
  ISearchDropDownBadge,
  IFormOverviewModel,
  CampaignService,
  AppFormService,
  CampaignTypeEnumm,
  CampaignSignalService,
  BUTTON_TEXT,
  QRCodeService,
  ReopenParticipationDialogService,
} from '@sml/utility';
import { ViewStoryComponent } from '@sml/preview-story';
import { DialogComponent } from '@sml/dialog';
import {
  catchError,
  combineLatest,
  filter,
  first,
  map,
  mergeMap,
  of,
  startWith,
  Subscription,
  switchMap,
} from 'rxjs';
import { LightboxComponent } from '@sml/lightbox';
import { environment } from '@env/environment';
import { FORM_DETAIL_STRINGS, SurveyComponent } from '@sml/survey-js';
import { ButtonsModule } from '@sml/buttons';
import { DrawerComponent } from '@sml/drawer';
import { BuildItemsComponent } from '@sml/build-items';
import { IconsComponent } from '@sml/icons';
import { UPDATE_ITEM_STRINGS } from 'libs/features/campaign/update-item/src/lib/update-item.constant';
import { DialogManagerLoaderService } from './services/dialog-manager-loader.service';
import { ReopenParticipationDialogLoaderService } from './services/reopen-participation-dialog-loader.service';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ToastrComponent,
    SpinnerComponent,
    FormSpinnerComponent,
    ViewStoryComponent,
    DialogComponent,
    LightboxComponent,
    SurveyComponent,
    ButtonsModule,
    DrawerComponent,
    BuildItemsComponent,
    IconsComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit , OnDestroy{
  public isProposeForm = false;
  formTitle = '';
  formDescription = '';
  isCalledFromItemDrawer = false
  public communityData: any;
  public showSpinner = false;
  previewStory = false;
  storyData = signal<Partial<StoryDialogConfig> | null>(null);
  itemData = signal<any[]>([]);
  convertedItemData: ICampaignItem | undefined;
  originalDescription = '';
  previewFormData: any = {};
  isVolunteer = false;
  customItemPrice: number | null = null;
  ticketQuantity: number | null = null;
  selectedShift: any = null;
  showParticipate = false;
  showParticipateConfirmation = false;
  showParticipateConfirmationHeader = '';
  errormsg = '';
  timeZoneData!: any;
  isItemDrawerOpen = false;
  isMobileView: boolean = false;
  public isIframe = false;
  showCancelSurveyDialog: boolean = false;
  showCancelDialog: boolean = false;
  formDetailStrings = FORM_DETAIL_STRINGS;
  itemStatusEnum= ITEM_STATUS_TYPE
  public isSetQuantityClick=false
  campaignStatus = CampaignTypeEnumm;
  public formListingDict: { [key: number]: { isTemplateForm: boolean; id: number } } = {};
  public customForms: { label: string; value: number, badge?: ISearchDropDownBadge }[] = [];
  formOverviewModel!: IFormOverviewModel
  public buildItemComponentRef = viewChild(BuildItemsComponent);
  itemStatusType = ITEM_STATUS_TYPE
  isInteractiveTourCampaign = false;
  @ViewChild('smlModal') smlModal!: DialogComponent;
  @ViewChild('smlCloneModal') smlCloneModal!: DialogComponent;
  private readonly reopenDialogService = inject(ReopenParticipationDialogService);
  isClick = false;
  cloneItem=false;
  isDeleteClick = false;
  updateItemString = BUTTON_TEXT;
  popupStrings = UPDATE_ITEM_STRINGS;
  public isMobile=false;
  isDrawerOpen = false;
  isPrivateUrl=false;
  qrCodeImageUrl: string | undefined;
  showCreateCustomFormDialog = false;
  private readonly toastr = inject(ToastrService);
  isFromCommunityStories = computed(() => {
    const campaignId = this.storyData()?.campaignId;
    return !campaignId || campaignId === 0
  });
  isCloseItemDrawerClicked: boolean = false;
  isSharedLoggedOutUser: boolean = false;
  isFromCommunityStoriesPage:boolean=false;
  isFromStoryTellerPage:boolean=false;
  isFromPlaques:boolean=false;
  private spinnerShown = false;
  private spinnerHidden = false;
  private routerSubscription!: Subscription;
  requireApplicantApproval=false;
  selectedDiscountGroups: any[] = [];
 // Inject dialog manager loader services for dynamic dialog loading
  private readonly dialogManagerLoader = inject(DialogManagerLoaderService);
  private readonly reopenParticipationDialogLoader = inject(ReopenParticipationDialogLoaderService);
  constructor(
    private readonly spinnerService: SpinnerService,
    private readonly cdr: ChangeDetectorRef,
    public viewStoryService: ViewStoryService,
    private readonly plaqueService: StoryPlaquesService,
    private readonly itemService: ItemService,
    private readonly customizePlaqueService: CustomizePlaquesService,
    private readonly communitySignalService: CommunitySignalService,
    private readonly storytellerSignalService: StorytellerSignalSignalService,
    private readonly router: Router,
    private readonly titleService: TitleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly plateformService: PlatformService,
    private participateService: ViewParticipateService,
    private readonly campaignService: CampaignService,
    private readonly appFormService: AppFormService,
    private readonly toastrService: ToastrService,
    private readonly campaignSignalService: CampaignSignalService,
    private readonly qrCodeService: QRCodeService,
    @Inject(PLATFORM_ID) private readonly platformId: object,

  ) {

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // route is about to change (back/forward or programmatic)
        if (this.isItemDrawerOpen) {
          this.closeDrawer();
        }
      }
    }); 
  }

 ngOnInit() {
    if (this.plateformService.browser()) {
      this.isIframe = window.self !== window.top;
      this.isMobileView = window.innerWidth < 768;
     
      // ✅ Hide initial loader from index.html after first navigation completes
      // This ensures Angular has bootstrapped, routing is complete, and initial route is activated
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          first()
        )
        .subscribe(() => {
          const loader = document.getElementById('app-loader');
          if (loader) {
            // Small delay to ensure smooth transition
            setTimeout(() => {
              loader.style.display = 'none';
            }, 200);
          }
        });
    }
   
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.viewStoryService.hide();
      });
    this.spinnerService.getSpinerState().subscribe((state: boolean) => {
      this.showSpinner = state;
      this.cdr.detectChanges();
    });
 
    this.router.events
      .pipe(
        startWith(this.router.events),
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        if (event?.['title']) {
          this.titleService.updateTitle(event['title']);
        }
        if (event?.['description']) {
          this.titleService.updateDescription(event['description']);
        }
      });
      
      this.checkWindowSize();
  }

  isValidUser = computed(() => {
    return (
      this.communitySignalService.signalIsValidCommunityUser() ||
      this.storytellerSignalService.signalIsValidStoryteller()
    );
  });

  $effect = effect(() => {
    const showConfig = this.viewStoryService.toggle();
    if (showConfig) {
      this.isInteractiveTourCampaign = showConfig.isInteractiveTourCampaign || false;
      this.isPrivateUrl=showConfig.isPrivateLink || false;
     if (this.router.url.includes('/preview')) {
      // PREVIEW → show once only
      if (!this.spinnerShown) {
        this.spinnerService.showSpinner();
        this.spinnerShown = true;
      }
    } else {
      // NORMAL → show every time
      this.spinnerService.showSpinner();
    }
      this.getStoryData(showConfig);
    } else {
      this.isPrivateUrl=false;
      this.previewStory = false;
    }


    const showParticipateConfig = this.participateService.participateToggle();
    this.selectedDiscountGroups = showParticipateConfig?.selectedDiscountGroups || [];
    if (showParticipateConfig) {
      const itemData = showParticipateConfig?.itemData;
      this.previewFormData = showParticipateConfig?.schema || itemData?.formSchema || {};
      this.communityData = showParticipateConfig.communityData;
      this.isProposeForm = showParticipateConfig.isProposeForm || false;
      this.formTitle = showParticipateConfig.title || itemData?.formTitle || '';
      this.formDescription = showParticipateConfig.description || itemData?.formDescription || '';
      this.timeZoneData = showParticipateConfig?.timeZoneData;
      this.itemData.set({
        ...itemData,
      });
      this.isCalledFromItemDrawer = showParticipateConfig.isCalledFromItemDrawer ? true : false
      this.showParticipate = true;
      this.previewStory = false;
      this.customItemPrice = showParticipateConfig.customItemPrice ? +showParticipateConfig.customItemPrice : null;
      this.ticketQuantity = showParticipateConfig.ticketQuantity ?? null;
      this.isVolunteer = showParticipateConfig.isVolunteer || false;
      this.selectedShift = showParticipateConfig.selectedShift || null;
    } else {
      this.participateService.hideParticipate();
      this.showParticipate = false;
      this.ticketQuantity = null;
    }

    const showParticipateConfConfig = this.participateService.participateconfToggle();
    if (showParticipateConfConfig) {
      this.showParticipateConfirmation = true;
      this.showParticipateConfirmationHeader = showParticipateConfConfig.header || '';
      if (showParticipateConfConfig.error) {
        this.errormsg = showParticipateConfConfig.error;
      }
    }

    const closeParticipateConfPopup = this.participateService.participateconfToggleClose();
    if (closeParticipateConfPopup) {
      this.showCancelSurveyDialog = true;
    }
    else {
      this.showCancelSurveyDialog = false;
    }
  });

  onCloseContributionModal() {
    this.showParticipateConfirmation = false;
    this.participateService.hideParticipateconf();

  }

  onConfirmCloseFormDialog() {
    this.closeParticipateModal();
    this.onClosePopup();
  }


  openCloneModal(val:boolean){
  this.cloneItem=val;
    this.smlCloneModal.openModal();
  }

  cancelDuplicateModal(){
    this.cloneItem=false;
    setTimeout(() => {
      this.smlCloneModal.closeModal();
    }, 100);
  }

  cloneCampaignItem(){
    this.cloneItem=false;
    this.spinnerService.showSpinner();
    this.itemService.cloneItem(this.storyData()?.campaignId ?? 0, this.storyData()?.itemId ?? 0)
    .subscribe(() => {
      this.toastr.success({
        message: '',
        title: 'Item cloned successfully',
        close: false,
      });
      this.closeModal();
      this.campaignSignalService.triggerRefresh();
        setTimeout(() => {
          this.spinnerService.hideSpinner();
        }, 1000);
    });
  }

  onClosePopup() {
    this.participateService.hideParticipateConfPopup();
  }

  private getItemDetails(plaqueId?: number, itemId?: number) {
    if (itemId) {
      return this.itemService.getItemDetailById(itemId,this.isPrivateUrl);
    } else if (plaqueId) {
      return this.customizePlaqueService
        .GetPlaqueItemDetails(plaqueId)
        .pipe(
          switchMap((data) =>
            data.id ? this.itemService.getItemDetailById(data.id,this.isPrivateUrl) : of(null)
          )
        );
    }
    return of(null);
  }

  onCloseFormDialog(): void {
    this.onClosePopup();
  }

  private getStoryDetails(plaqueId?: number) {
    return plaqueId ? this.plaqueService.GetStoryDetails(plaqueId) : of(null);
  }

  handleFallBack(item: ItemModel): void {
    if (item.campaignId && item.campaignIsPublic) {
      this.router.navigate(['/community', item.communityId, 'campaign', item.campaignId]);
    }
    else {
      this.router.navigate(['/community', item.communityId]);
    }
  }

  private getStoryData(showConfig: StoryDialogConfig) {
    return combineLatest([
      showConfig.story
        ? of(showConfig.story)
        : this.getStoryDetails(showConfig.plaqueId),
      showConfig.item
        ? of(showConfig.item)
        : this.getItemDetails(showConfig.plaqueId, showConfig.itemId).pipe(
          catchError(error => {
            // Handle the error here (e.g., log it, return a default value, etc.)
            console.error('Error fetching item details:', error);
            // Return a fallback value if needed
            this.spinnerService.hideSpinner();
            this.closeModal();
            return of(null);  // Or a default value that makes sense in your context
          })
        ),
    ])
      .pipe(
        switchMap(([story, item]) => this.getData(story, item))
      )
      .subscribe(({ story, item }) => {
                if (!this.isValidUser() || !showConfig.accessDraft) {
          if (!item?.isPosted && !this.isPrivateUrl) {
            if (story) {
              item = null;
            }
            else {
              this.handleFallBack(item!);
              return;
            }
          }
          if (!story?.isLive) {
            story = null;
          }
        }
        // show if for the preview story
        if (showConfig.enableMeta) {

          if (story) {
            this.setMetaForStory(story);
          } else if (item) {
            this.setMetaForItem(item);
          }
        }
        this.isFromPlaques=this.router.url.includes('/plaques');
        this.isFromCommunityStoriesPage = this.router.url.includes('/stories');
        this.isSharedLoggedOutUser = this.router.url.includes('/preview');
        this.isFromStoryTellerPage=this.router.url.includes('/storyteller');
        this.isInteractiveTourCampaign = item && item.campaignTypeId === CampaignTypeEnumm['Interactive Tour'] ? true : false;
        this.storyData.set({
          ...showConfig,
          story,
          item,
          selectedTab: this.isInteractiveTourCampaign && !this.isFromCommunityStoriesPage && !this.isFromStoryTellerPage && !this.isSharedLoggedOutUser && !this.isFromPlaques ? 'item' : (story || !item ? 'story' : 'item'),
          isInteractiveTourCampaign: this.isInteractiveTourCampaign
        });
        this.convertedItemData = this.convertItemModelToCampaignItem(item);
        this.originalDescription = item?.originalDescription || '';
        this.previewStory = true;
        const storyItem = this.storyData()?.item;
        if(storyItem?.shifts && storyItem.shifts.length > 0 && storyItem.statusId === ITEM_STATUS_TYPE.Donated){
          storyItem.statusId = ITEM_STATUS_TYPE.UnAvailable;
        }
       if (this.isSharedLoggedOutUser) {
      // PREVIEW → hide once only
      if (!this.spinnerHidden) {
        this.spinnerService.hideSpinner();
        this.spinnerHidden = true;
      }
    } else {
      // NORMAL → hide every time
      this.spinnerService.hideSpinner();
    }
      });
  }

  private getData(story: IStoryModel | null, item: ItemModel | null) {
    if (!story && item?.plaqueId) {
      return this.plaqueService.GetStoryDetails(item.plaqueId)
        .pipe(
          map((story) => ({
            story,
            item
          }))
        )
    }
    return of({
      story,
      item
    });
  }

  private validateStoryAccess(story: any, accessDraft: boolean): any {
    if (!this.isValidUser() || !accessDraft) {
      return story?.isLive ? story : null;
    }
    return story;
  }

  private validateItemAccess(item: any, accessDraft: boolean): any {
    if (!this.isValidUser() || !accessDraft) {
      return item?.isPosted ? item : null;
    }
    return item;
  }

  private setMetaTagsIfEnabled(enableMeta: boolean, story: any, item: any): void {
    if (!enableMeta) return;

    if (story) {
      this.setMetaForStory(story);
    } else if (item) {
      this.setMetaForItem(item);
    }
  }
  closeDrawer() {
    this.isItemDrawerOpen = false;
  }

  handleBackClick(backClick: boolean): void {
    this.isCloseItemDrawerClicked = true;
    if (backClick) {
      this.isClick = false;
      this.isDeleteClick = false;
      this.smlModal.openModal();
    }
  }

  private setMetaForStory(res: IStoryModel): void {
    let title = 'Digital Story | SeeMyLegacy';
    let desc = 'Explore the Story';
    if (res.coverPage.title) {
      title = `${res.coverPage.title} | Digital Story`;
      desc = `Explore the Story: ${res.coverPage.title}`;
    }
    this.titleService.updateTitle(title);
    this.titleService.updateDescription(desc);
    this.titleService.updateOgUrl(environment.webUrl + `/preview?storyId=${res.plaqueId}`);
    if (res.coverPage && res.coverPage.blobUrl) {
      const [image] = JSON.parse(res.coverPage.blobUrl) as IFileModel[];
      if (image)
        this.titleService.updateOgImage(image.BlobUrl);
    }
  }

  private setMetaForItem(res: ItemModel): void {
    const title = res.campaignName ? `${res.name} | ${res.campaignName}` : res.name;
    if (res.statusId == ITEM_STATUS_TYPE.Available) {  //available
      const desc = `The ${res.communityName} invites you to participate in ${res.campaignName}. Click to learn more and take part: ${res.name}!`
      this.titleService.updateDescription(desc);
    }
    else if (res.statusId == ITEM_STATUS_TYPE.Donated) {  //donated
      const desc = `Click to learn more and engage: ${res.name}!`
      this.titleService.updateDescription(desc);
    }
    this.titleService.updateTitle(title);
    this.titleService.updateOgUrl(environment.webUrl + `/preview?itemId=${res.id}`);
    if (res && res.blobUrls) {
      const [image] = JSON.parse(res.blobUrls) as IFileModel[];
      if (image)
        this.titleService.updateOgImage(image.BlobUrl);
    }
  }

  closeModal() {
    this.viewStoryService.hide();
  }
  downloadImage() {
    if (this.qrCodeImageUrl) {
      const a = document.createElement('a');
      a.href = this.qrCodeImageUrl;
      a.download = this.storyData()?.item?.name + '-QR';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
    generateQrCode(): void {
    this.spinnerService.showSpinner();
    this.qrCodeService.getQRCodeBasedOnUrl(environment.webUrl + '/preview?itemId=' + this.storyData()?.item?.id)
      .subscribe({
        next: (response) => {
          this.qrCodeImageUrl = `data:image/png;base64,${response}`;
          this.spinnerService.hideSpinner();
        },
        error: (err) => {
          this.spinnerService.hideSpinner();
          console.error('Error generating QRCode:', err);
        },
      });
  }
  closeItem(): void {
    if (this.buildItemComponentRef()?.getFormStatus()) {
      this.buildItemComponentRef()?.form.markAllAsTouched();
      return;
    }
    this.isClick = false;
    this.isSetQuantityClick = true;
    this.smlModal.openModal();
  }

  reopenItem(typeId : number): void {
    if (this.buildItemComponentRef()?.getFormStatus()) {
      this.buildItemComponentRef()?.form.markAllAsTouched();
      return;
    }
    const child = this.buildItemComponentRef();
    const volunteerShifts = child?.getVolunteerShifts() ?? [];
    this.reopenDialogService.openDialog({
      volunteerShifts,
      isTicket: typeId === this.campaignStatus['Ticketing'],
      onConfirm: (shifts, quantity) => {
        if (!child) return;
        if (shifts.length > 0) {
          child.reopenParticipationWithShifts(shifts, false);
        } else {
          if (!quantity || quantity <= 0) return;
          child.reopenParticipation(quantity, false);
        }
        this.isCloseItemDrawerClicked = false;
      },
      onCancel: () => {
        this.isItemDrawerOpen = true;
      },
    });
  }

  setItemQuantityToZero(): void {
  if (this.buildItemComponentRef) {
    const child = this.buildItemComponentRef();
    if (child) {
      child.setQuantityToZero(false);
    }
  }
  this.smlModal.closeModal();
  this.isCloseItemDrawerClicked = false;
  this.isSetQuantityClick=false;
}
  checkWindowSize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 768;
    }
  }
  closeParticipateModal() {
    this.participateService.hideParticipate();
    this.showParticipate = false;
    this.ticketQuantity = null;
  }
  openItemDrawer(value: boolean) {
    setTimeout(() => {
      this.loadFormListing(this.storyData()?.item?.communityId ?? 0);
    }, 10);
    if (value) {
      this.isItemDrawerOpen = true;
    }
    const campaignDetail = this.campaignSignalService.getCampaignDetail();
    if(campaignDetail){
      this.requireApplicantApproval = campaignDetail ? campaignDetail.requireApplicantApproval : false;
    }
    this.campaignService.getCampaignTypeStandardForm(this.storyData()?.item?.campaignTypeId ?? 0).subscribe({
      next: (res) => {
        if (res) {
          this.formOverviewModel = {
            title: res.title ?? '',
            description: res.description ?? '',
            schema: res.schema ?? ''
          };
        }
      }
    })
  }
   handleClose(isClose: boolean) {
    this.isDrawerOpen = !isClose;
  }
  
    copyImage() {
      if (!this.qrCodeImageUrl) {
        console.error("No QR Code available to copy.");
        return;
      }
      fetch(this.qrCodeImageUrl)
        .then(res => res.blob())
        .then(blob => {
          const clipboardItem = new ClipboardItem({ "image/png": blob });
  
          navigator.clipboard.write([clipboardItem])
            .then(() => {
              this.toastr.default({
                message: '',
                title: 'Item QR copied',
                icon: 'copy',
                close: false,
              })
            })
            .catch(err => {
              console.error("Failed to copy QR Code:", err);
            });
        });
    }
   openQRcodeGenerateDrawer(value: boolean) {
    if (value) {
      this.generateQrCode();
      this.isDrawerOpen = true;
    }
  }

  isSave(): void {
    if (this.isCloseItemDrawerClicked && !this.isClick) {
      this.smlModal.closeModal();
      this.isItemDrawerOpen = false;
      return;
    }
    if (this.isClick) {
      if (this.buildItemComponentRef) {
        this.buildItemComponentRef()?.handleSubmit();
      }
    }
    //  else {
    //   this.sessionStorageService.removeData('addupdateitemObj');
    //   this.checkNavigation();
    // }
    this.smlModal.closeModal();
    this.isCloseItemDrawerClicked = false;

  }


  deleteItem(): void {
    if (this.storyData()?.item?.isDonorActivityAssociated) {
      this.toastrService.error({ message: `Cannot delete '${this.storyData()?.item?.name}' as it has an activity log associated with it. But you can make it Private.` });
    }
    else {
      this.isClick = false;
      this.isDeleteClick = true;
      this.smlModal.openModal();
    }
  }

  cancel(): void {
   this.isSetQuantityClick=false;
    this.isItemDrawerOpen = true;
    this.isDeleteClick = false;
    this.isClick = false;
    this.smlModal.closeModal();
  }

  onSaveClick(): void {
    if (this.buildItemComponentRef()?.form.invalid) {
      this.buildItemComponentRef()?.form.markAllAsTouched();
      return;
    }
     if (this.buildItemComponentRef()?.checkDiscountGroupValidation()) {
      return;
    }
    else {
      this.isDeleteClick = false;
      this.isClick = true;
      this.smlModal.openModal();
    }
  }
  
  public onDelete(): void {
    const itemId = this.storyData()?.item?.id;
    const campaignId = this.storyData()?.campaignId;
    const viewType = this.storyData()?.viewType;

    if (!itemId) {
      this.toastrService.error({
        message: 'No item available for deletion',
        title: 'Delete Error'
      });
      return;
    }

    this.spinnerService.showSpinner();
    this.itemService.deleteItem(itemId).subscribe({
      next: (response) => {
        this.spinnerService.hideSpinner();
        this.smlModal.closeModal();
        if (response) {
          // Close the drawer and modal after successful deletion
          this.closeDrawer();
          this.closeModal();

          // Trigger refresh for all contexts
          this.campaignSignalService.triggerRefresh();


        } else {
          this.toastrService.error({
            message: 'Failed to delete item',
            title: 'Delete Error'
          });
        }
      },
      error: (error) => {
        console.error('Error deleting item:', error);
        this.spinnerService.hideSpinner();
        this.smlModal.closeModal();
        this.toastrService.error({
          message: 'An error occurred while deleting the item. Please try again.',
          title: 'Delete Error'
        });
      }
    });
  }
  private loadFormListing(communityId: number): void {
    this.appFormService.getFormListing(communityId).subscribe({
      next: (formListingDtos) => {
        const customForms = formListingDtos.filter(x => !x.isTemplateForm);
        const templateForms = formListingDtos.filter(x => x.isTemplateForm);
        const concatForms = this.isBuildFromScratch() ? [...customForms] : [...customForms, ...templateForms];

        this.formListingDict = concatForms.reduce(
          (acc, item, index) => {
            acc[index + 1] = { isTemplateForm: item.isTemplateForm, id: item.id };
            return acc;
          }, {} as { [key: number]: { isTemplateForm: boolean; id: number } }
        );

        this.customForms = concatForms.map((form, index) => {
          if (this.isBuildFromScratch()) {
            return ({ label: `${!form.isTemplateForm ? form.formId + ' - ' : ''}${form.nickname}`, value: index + 1, })
          }
          else {
            // eslint-disable-next-line prefer-const
            let badge: ISearchDropDownBadge = form.isTemplateForm ? {
              type: "mercury",
              label: "Template Form",
              showIcon: false,
            } : {
              type: "mercury",
              label: "Your Form",
              showIcon: false,
            }
            return (
              {
                label: `${!form.isTemplateForm ? form.formId + ' - ' : ''}${form.nickname}`,
                value: index + 1,
                badge: badge
              })
          }
        });
      },
      error: (err) => {
        console.error('Failed to load form listings', err);
        this.formListingDict = {};
      }
    });
  }
  isBuildFromScratch() {
    return true;
  }
  getDeleteDynamicText(id: number): string {
    if (this.storyData()?.item?.statusId === this.itemStatusType.Donated) {
      if (id == this.campaignStatus['Interactive Tour']) {
        return 'Delete Stop';
      }
      else if (id == this.campaignStatus['Volunteer Activity']) {
        return 'Delete Event';
      }
      else if (id == this.campaignStatus['Memorial Program']) {
        return 'Delete Donation';
      }
      else if (id == this.campaignStatus['Fundraiser']) {
        return 'Delete Donor';
      }
      else if (id == this.campaignStatus['Registration']) {
        return 'Delete Participant';
      }
      else if (id == this.campaignStatus['Sponsorship']) {
        return 'Delete Sponsor';
      }
      else if(id == this.campaignStatus['Ticketing']){
        return 'Delete Ticket';
      }
    }
    else {
      return 'Delete Option';
    }
    return 'Delete Item';
  }
  getDrawerHeading(id: number, isDrawer=false): string {
    if (this.storyData()?.item?.statusId !== this.itemStatusType.Donated) {

      if (id == this.campaignStatus['Interactive Tour']) {
        return 'Stop';
      }
      else if (id == this.campaignStatus['Volunteer Activity']) {
        return 'Volunteer Option';
      }
      else if (id == this.campaignStatus['Memorial Program']) {
        return 'Memorial Option';
      }
      else if (id == this.campaignStatus['Fundraiser']) {
        return 'Donation Option';
      }
      else if (id == this.campaignStatus['Registration']) {
        return 'Registration Option';
      }
      else if (id == this.campaignStatus['Sponsorship']) {
        return 'Sponsorship Option';
      }
      else if(id == this.campaignStatus['Ticketing'] && !isDrawer){
        return 'Ticket';
      }
      else if(id == this.campaignStatus['Ticketing'] && isDrawer){
        return 'Ticket Option';
      }
    }
    else if (this.storyData()?.item?.statusId === this.itemStatusType.Donated) {
      if (id == this.campaignStatus['Interactive Tour']) {
        return 'Stop';
      }
      else if (id == this.campaignStatus['Volunteer Activity']) {
        return 'Completed Event';
      }
      else if (id == this.campaignStatus['Memorial Program']) {
        return 'Donation';
      }
      else if (id == this.campaignStatus['Fundraiser']) {
        return 'Donor';
      }
      else if (id == this.campaignStatus['Registration']) {
        return 'Participant';
      }
      else if (id == this.campaignStatus['Sponsorship']) {
        return 'Sponsor';
      }
      else if(id == this.campaignStatus['Ticketing'] && !isDrawer){
        return 'Ticket';
      }
      else if(id == this.campaignStatus['Ticketing'] && isDrawer){
        return 'Unavailable Ticket';
      }
    }
    return 'Item';
  }


  /**
   * Converts ItemModel to ICampaignItem for the build-items component
   */
  public convertItemModelToCampaignItem(itemModel: ItemModel | null | undefined): ICampaignItem | undefined {
    if (!itemModel) {
      return undefined;
    }

    const itemDetails: ItemDetails = {
      name: itemModel.name,
      typeId: itemModel.typeId,
      statusId: itemModel.statusId,
      description: itemModel.description,
      isPosted: itemModel.isPosted ? POST_ITEM_TYPE.Public : POST_ITEM_TYPE.Private,
      gallaryBlob: itemModel.blobUrls || '[]',
      documentsBlob: itemModel.documentBlobUrls || '[]',
      itemId: itemModel.itemId,
      accessType: itemModel.accessType,
      itemCustomMessage:itemModel.itemCustomMessage,
    };

    const location: LocationDetails = {
      locationName: itemModel.locationName,
      address: itemModel.address,
      longitude: itemModel.itemLongitude || undefined,
      latitude: itemModel.itemLatitude || undefined
    };

    const priceModel: PriceModel = {
      price: itemModel.price || undefined,
      customMinPrice: itemModel.customMinPrice,
      customMaxPrice: itemModel.customMaxPrice,
      quantity: itemModel.quantity,
      remainingQuantity: itemModel.remainingQuantity,
      participationMethod: itemModel.participationMethod,
      customItemFormLink: itemModel.customItemFormLink,
      isAcceptPaymentOnline: itemModel.isAcceptPaymentOnline,
      formType: itemModel.formTypeId,
      formMasterId: itemModel.formMasterId,
      sortOrder: itemModel.sortOrder,
      isUnlimitedParticipation: itemModel.isUnlimitedParticipation,
      isFreeTicket: itemModel.isFreeTicket,
      hasDiscountGroups: itemModel.hasDiscountGroups ?? false,
    };

    const donation: Donation | undefined = (itemModel.donatedBy || itemModel.dedicatedTo || itemModel.plaqueId) ? {
      donatedBy: itemModel.donatedBy || '',
      dedicatedTo: itemModel.dedicatedTo || '',
      qrPlaque: itemModel.plaqueId?.toString() || '',
      qrPlaqueName: itemModel.plaqueName || undefined
    } : undefined;

    const itemEventModel: ItemDates = {
      hasEventTimeEntered: itemModel.hasEventTimeEntered,
      itemDateEventType: itemModel.itemDateEventType,
      itemEventStartTime: itemModel.itemEventStartTime || null,
      itemEventEndTime: itemModel.itemEventEndTime || null,
      itemEventTimeZone: itemModel.eventTimeZone,
      hasShifts: itemModel.hasShifts
    };

    return {
      id: itemModel.id.toString(),
      isNew: false,
      itemDetails,
      location,
      priceModel,
      donation,
      itemListingType: itemModel.itemListingType,
      itemEventModel,
      shifts: itemModel.shifts,
      discountGroups: itemModel.discountGroups,
    };
  }

   ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  onCloseParticipationDialogClosed(): void {
  if (this.isMobileView && (this.isSetQuantityClick || this.isDeleteClick)) {
    this.isSetQuantityClick = false;
    this.isDeleteClick=false;
  }
}

}
